import FormField from '../../../../../components/FormField';
import * as S from './styles';

interface ThemedInputProps {
    labelValue: string;
    labelColor: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur: () => void;
    hasError: boolean;
    fieldValue: string;
    errorMessage: string;
    type?: string;
}

export const ThemedInput = ({
    labelColor,
    ...formFieldProps
}: ThemedInputProps) => (
    <S.Wrapper $labelColor={labelColor}>
        <FormField {...formFieldProps} />
    </S.Wrapper>
);
